// Product Detail Page Constants and Data

// Technical Specifications for Privacy Booths
export const PRIVACY_BOOTH_TECH_SPECS = {
  description: "Privacy Booth - a perfect secluded space with power and connectivity seamlessly imbibed.",
  specs: [
    { label: 'Exterior Finish', value: 'Laminate' },
    { label: 'Interior Finish', value: 'Acoustic Panel' },
    { label: 'Door', value: 'Transparent Glass' },
    { label: 'Ventilation', value: '6" Grill Fan with Adaptor\n2500rpm Speed\n80CFM Air Flow with 25db' },
    { label: 'Electrical Usage', value: 'Via Motion Sensor' },
    { label: 'Pop-up Box', value: 'Power Socket, CAT VI, Telephone' }
  ]
};

// Optional Accessories for Meeting Booth Large
export const MEETING_BOOTH_LARGE_ACCESSORIES = {
  seatingBench: {
    id: 'seating-bench',
    name: 'Seating Bench',
    material: 'Prelaminated particle board structure with 2" thick Seat and Back with fabric upholstered finish',
    size: '1100mm (L) x 525mm (D) x 50mm thk',
    mrp: 11400,
    price: Math.round(11400 * 0.7),
    maxQty: 10
  },
  table: {
    id: 'meeting-table',
    name: 'Table',
    material: 'Prelaminated particle board top with powdercoated metal base',
    size: '900mm (L) x 500mm (D) x 750mm (H)',
    mrp: 9287,
    price: Math.round(9287 * 0.7),
    maxQty: 10
  }
};

// Optional Accessories for Meeting Booth (Duo - 2 person)
export const MEETING_BOOTH_ACCESSORIES = {
  chairs: {
    id: 'meeting-chair',
    name: 'Meeting Chair',
    material: 'Ergonomic mesh back chair with cushioned seat',
    size: 'Standard office chair dimensions',
    mrp: 5500,
    price: Math.round(5500 * 0.7),
    maxQty: 10
  },
  table: {
    id: 'duo-table',
    name: 'Circular Table',
    material: 'Prelaminated particle board top with powdercoated metal base',
    size: '600mm diameter x 750mm (H)',
    mrp: 7500,
    price: Math.round(7500 * 0.7),
    maxQty: 10
  }
};

// Inclusions for workstation products
export const WORKSTATION_INCLUSIONS = [
  'Table Top',
  'Metal Base',
  'Levelers',
  'Metal Beam',
  'Connector Sockets',
  'Privacy Screen',
  'Screen Holder Studs',
  'Wire Manager'
];

// Inclusions for Two Drawer Pedestal
export const TWO_DRAWER_INCLUSIONS = [
  'Storage Box with Two Pull-out Drawers',
  'Individual Lock & Key'
];

// Inclusions for Three Drawer Pedestal
export const THREE_DRAWER_INCLUSIONS = [
  'Storage Box with Three Pull-out Drawers',
  'Centralised Lock & Key'
];

// Inclusions for Phone Booth (HushPod Solo)
export const PHONE_BOOTH_INCLUSIONS = [
  'Phone Booth with Openable Door',
  'Ledge for Laptop',
  'Electric Pop Up Box on Ledge',
  'Vertebra for Electrical Wire Concealing',
  'Motion Sensor',
  'LED Light Strip',
  'Exhaust Fan'
];

// Inclusions & Exclusions for Meeting Booth (HushPod Duo)
export const MEETING_BOOTH_DATA = {
  inclusions: [
    'Meeting Booth with Openable Door',
    'Circular Table',
    'Electric Pop Up Box',
    'Motion Sensor',
    'LED Light Strip',
    'Exhaust Fan'
  ],
  exclusions: [
    'Table',
    'Chairs'
  ]
};

// Inclusions & Exclusions for Meeting Booth Large (HushPod Quad)
export const MEETING_BOOTH_LARGE_DATA = {
  inclusions: [
    'Meeting Booth with Openable Door',
    'Electric Pop Up Box',
    'Motion Sensor',
    'LED Light Strip',
    'Exhaust Fan'
  ],
  exclusions: [
    'Table',
    'Seating Bench'
  ]
};

// Technical drawing images for products
export const TECHNICAL_DRAWINGS = {
  'Cluster of 2': {
    topView: 'https://customer-assets.emergentagent.com/job_2d903c81-e1a2-44f8-82cd-4f49b52d8c19/artifacts/167gvdh5_image.png',
    frontView: 'https://customer-assets.emergentagent.com/job_2d903c81-e1a2-44f8-82cd-4f49b52d8c19/artifacts/a6sneu94_image.png',
    sideView: 'https://customer-assets.emergentagent.com/job_2d903c81-e1a2-44f8-82cd-4f49b52d8c19/artifacts/jf6goi6y_image.png'
  },
  'Cluster of 4': {
    topView: 'https://customer-assets.emergentagent.com/job_2d903c81-e1a2-44f8-82cd-4f49b52d8c19/artifacts/1nmze7ur_image.png',
    frontView: 'https://customer-assets.emergentagent.com/job_2d903c81-e1a2-44f8-82cd-4f49b52d8c19/artifacts/xx6et86o_image.png',
    sideView: 'https://customer-assets.emergentagent.com/job_2d903c81-e1a2-44f8-82cd-4f49b52d8c19/artifacts/4ngv3bak_image.png'
  },
  'Cluster of 4 Large': {
    topView: 'https://customer-assets.emergentagent.com/job_2d903c81-e1a2-44f8-82cd-4f49b52d8c19/artifacts/s490q9mj_image.png',
    frontView: 'https://customer-assets.emergentagent.com/job_2d903c81-e1a2-44f8-82cd-4f49b52d8c19/artifacts/2f2fvmsc_image.png',
    sideView: 'https://customer-assets.emergentagent.com/job_2d903c81-e1a2-44f8-82cd-4f49b52d8c19/artifacts/xtzrest3_image.png'
  },
  'Two Drawer Pedestal': {
    dimensions: 'https://customer-assets.emergentagent.com/job_2d903c81-e1a2-44f8-82cd-4f49b52d8c19/artifacts/tuqc0prt_image.png'
  },
  'Three Drawer Pedestal': {
    dimensions: 'https://customer-assets.emergentagent.com/job_2d903c81-e1a2-44f8-82cd-4f49b52d8c19/artifacts/ppsn7gvy_image.png'
  },
  'Phone Booth': {
    topView: 'https://customer-assets.emergentagent.com/job_2d903c81-e1a2-44f8-82cd-4f49b52d8c19/artifacts/angr8w8c_image.png',
    frontView: 'https://customer-assets.emergentagent.com/job_2d903c81-e1a2-44f8-82cd-4f49b52d8c19/artifacts/9dx1yy2a_image.png'
  },
  'Meeting Booth': {
    topView: 'https://customer-assets.emergentagent.com/job_2d903c81-e1a2-44f8-82cd-4f49b52d8c19/artifacts/4rpql5ql_image.png',
    frontView: 'https://customer-assets.emergentagent.com/job_2d903c81-e1a2-44f8-82cd-4f49b52d8c19/artifacts/yw6fh6y1_image.png'
  },
  'Meeting Booth Large': {
    topView: 'https://customer-assets.emergentagent.com/job_2d903c81-e1a2-44f8-82cd-4f49b52d8c19/artifacts/5248yu0d_image.png',
    frontView: 'https://customer-assets.emergentagent.com/job_2d903c81-e1a2-44f8-82cd-4f49b52d8c19/artifacts/lmul1ptx_image.png'
  }
};

// Helper functions
export const isPrivacyBooth = (subcategory) => {
  return ['Phone Booth', 'Meeting Booth', 'Meeting Booth Large'].includes(subcategory);
};

export const getProductDrawings = (subcategory) => {
  return TECHNICAL_DRAWINGS[subcategory] || {};
};

export const getProductInclusions = (subcategory) => {
  if (['Cluster of 2', 'Cluster of 4', 'Cluster of 4 Large'].includes(subcategory)) {
    return { inclusions: WORKSTATION_INCLUSIONS };
  }
  if (subcategory === 'Two Drawer Pedestal') {
    return { inclusions: TWO_DRAWER_INCLUSIONS };
  }
  if (subcategory === 'Three Drawer Pedestal') {
    return { inclusions: THREE_DRAWER_INCLUSIONS };
  }
  if (subcategory === 'Phone Booth') {
    return { inclusions: PHONE_BOOTH_INCLUSIONS };
  }
  if (subcategory === 'Meeting Booth') {
    return MEETING_BOOTH_DATA;
  }
  if (subcategory === 'Meeting Booth Large') {
    return MEETING_BOOTH_LARGE_DATA;
  }
  return null;
};
